import React, { Component } from 'react';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
import PersianNumber,{ formatString } from "./../../helpers/persian-number/PersianNumber";


class DashboardBox extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 

        const {model}=this.props;

        return ( 
            <div className="row">
        <div className="col-lg-3 col-md-6">
            <div className="panel panel-primary">
            <div className="panel-heading">
                <div className="row">
                <div className="col-xs-5 text-left pull-left">
                    <i className="fa fa-envelope fa-5x"></i>
                </div>
                <div className="col-xs-7 pull-left text-right">
                    <div className="huge">
                        <CountUp end={model.NewMessagesCount || 0} duration={2} />                    </div>
                    <div>پیام جدید!</div>
                </div>
                </div>
            </div>
            <Link to="/message/inbox">
                <div className="panel-footer">
                <span className="pull-right">مشاهده جزییات</span>
                <span className="pull-left"><i className="fa fa-arrow-circle-left"></i></span>
                <div className="clearfix"></div>
                </div>
            </Link>
            </div>
        </div>
        <div className="col-lg-3 col-md-6">
            <div className="panel panel-green">
            <div className="panel-heading">
                <div className="row">
                <div className="col-xs-5 text-left pull-left">
                    <i className="fa fa-file fa-5x"></i>
                </div>
                <div className="col-xs-7 pull-left text-right">
                    <div className="huge">
                    <CountUp end={model.NewCertificationRequestCount || 0} duration={3} />
                    </div>
                    <div>پذیرش جدید!</div>
                </div>
                </div>
            </div>
            <Link to="/certrequestlist">
                <div className="panel-footer">
                <span className="pull-right">مشاهده جزییات</span>
                <span className="pull-left"><i className="fa fa-arrow-circle-left"></i></span>
                <div className="clearfix"></div>
                </div>
            </Link>
            </div>
        </div>
        <div className="col-lg-3 col-md-6">
            <div className="panel panel-yellow">
            <div className="panel-heading">
                <div className="row">
                <div className="col-xs-5 text-left pull-left">
                    <i className="fa fa-file fa-5x"></i>
                </div>
                <div className="col-xs-7 pull-left text-right">
                    <div className="huge">
                        <CountUp end={model.NewCertificationRequestFromOutCount || 0} duration={4} />
                    </div>
                    <div>درخواست پذیرش!</div>
                </div>
                </div>
            </div>
            <Link to="/certrequestlist">
                <div className="panel-footer">
                <span className="pull-right">مشاهده جزییات</span>
                <span className="pull-left"><i className="fa fa-arrow-circle-left"></i></span>
                <div className="clearfix"></div>
                </div>
            </Link>
            </div>
        </div>
        <div className="col-lg-3 col-md-6">
            <div className="panel panel-red">
            <div className="panel-heading">
                <div className="row">
                <div className="col-xs-5 text-left  pull-left">
                    <i className="fa fa-bookmark fa-5x"></i>
                </div>
                <div className="col-xs-7 pull-left text-right">
                <div className="huge">
                <CountUp end={model.FinishedCertReqsInMonthCount || 0} duration={4} />
                    </div>
                    <div>گواهی در ماه!</div>
                </div>
                </div>
            </div>
            <Link to="/certrequestlist">
                <div className="panel-footer">
                <span className="pull-right">مشاهده جزییات</span>
                <span className="pull-left"><i className="fa fa-arrow-circle-left"></i></span>
                <div className="clearfix"></div>
                </div>
            </Link>
            </div>
        </div>
        </div>
                    
         );
    }
}
 
export default DashboardBox;